module.exports = __webpack_public_path__ + "img/segworks.927ec49f.png";